import React from "react";
import './css/base.css';

const Loader = () => {
  return (
    <div className="spinner-container">
      <div class="spinner-traveller"></div>
    </div>
  );
};

export default Loader;
